export default [
  {
    text: 'Type',
    value: 'is_campaign_task',
    isPreview: true,
    sortable: false,
    isContactFiltered: true,
  },
  {
    text: 'Due Date',
    value: 'due_at',
    isPreview: true,
    isContactFiltered: true,
  },
  {
    text: 'Assignee',
    value: 'assigned_user',
    sortable: false,
    isPreview: true,
    isContactFiltered: true,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
    isPreview: true,
    isContactFiltered: true,
  },
  {
    text: 'Contact',
    value: 'contact',
    sortable: false,
    isPreview: true,
    isContactFiltered: false, // Don't show contact column on contact page
  },
  {
    text: 'Category',
    value: 'category',
    sortable: false,
    isPreview: true,
    isContactFiltered: true,
  },
  {
    text: '',
    value: 'name',
    sortable: false,
    isPreview: true,
    isContactFiltered: true,
  },
];
